/** Components */
import {
    RequestIdWithWarningAliado,
    replaceRequestId,
    RequestIdWithWarning,
    Causales,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';

import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ConsultMonitoring } from '../../components/utilities/Table/MonitoringConsult';

const commonColumns = [
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    {
        Header: 'Identificación',
        accessor: 'persona.numero_identificacion',
    },
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Marca',
        accessor: 'vehiculossolicitud.marca.label',
    },
    {
        Header: 'Linea',
        accessor: 'vehiculossolicitud.linea.label',
    },
];

export const requestsListStatus = [
    {
        id: 'tableAliado',
        label: 'POR COMPLETAR',
        status: 5,
        responsable: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(0, 0, RequestIdWithWarning());
            cols.splice(1, 0, {
                Header: 'Fecha Creación',
                accessor: 'created_at',
            });

            return cols;
        })(),
        buttonAction: [{ name: 'sendUrlClient' }],
    },
    {
        id: 'procesadas_mesa_de_ayuda',
        label: 'PROCESADAS',
        status: false,
        nameColumnProcessed: [
            {
                name: 'estado_solicitud__gt',
                value: 5,
                operator: '%26',
            },
            {
                name: 'aliados_concesionarios', //antes estaba gestionsolicitud__usuario_creacion y se cambio para que filtre las solicitudes asociadas a ese aliado asi las cree otro rol
                value: 'user',
                operator: '|',
            },
        ],
        responsable: false,
        columns: replaceRequestId(
            (() => {
                const cols = [...commonColumns];
                cols.splice(0, 0, RequestIdWithWarningAliado());
                cols.splice(1, 0, {
                    Header: 'Fecha Creación ',
                    accessor: 'gestionsolicitud.fecha_creacion',
                });
                cols.splice(7, 0, {
                    Header: 'Tel Cliente',
                    accessor: 'persona_info_contacto.celular',
                });

                cols.splice(8, 0, OfficeRequest);
                cols.splice(9, 0, ExecutiveWithTooltip);
                cols.splice(10, 0, StatusWithTooltip);
                cols.splice(12, 0, Causales());
                cols.splice(11, 0, ConsultMonitoring);

                return cols;
            })()
        ),
        registrationLimit: 5, // limit for registration in list credits
    },
];
